/* eslint-disable react/prop-types */
import React from 'react';

import {
  Select,
  MenuItem,
  Button,
} from '@material-ui/core';

import withStyles from '@material-ui/core/styles/withStyles';
import CaseSelect from './CaseSelect';
import SettingButton from './SettingButton';
import OpacitySelect from './OpacitySelect';
import settingSelect from './styles/SettingsSelectStyles';
import {materialTheme} from '../../../materialTheme'

const { palette } = materialTheme


const styles = () => ({
  ...settingSelect(palette),
  menuParams: {
    width: 252,
    height: 72,
  },
  moreSettings: {
    display: 'flex',
    gap: '0 12px',
  }
});

class MoreSettingsSelect extends React.Component {
  state = {
    isOpen: false,
    topPosition: 0,
    leftPosition: 0
  }

  setRef = ref => {
    this.ref = ref;
  }

  onRefChange = () => {
    const topPosition = this.ref.getBoundingClientRect().top + 60;
    const leftPosition = this.ref.getBoundingClientRect().left;
    this.setState({ topPosition, leftPosition });
  };

  someFunc() {
    this.setState({ isOpen: true });
    this.onRefChange();
  }

  render() {
    const { classes, changeSetting, layer } = this.props;
    const { isOpen, topPosition, leftPosition } = this.state;
    const settingIcons = {
      italic: (
        <svg>
          <mask id="path-1-inside-1" fill="white">
            <path fillRule="evenodd" clipRule="evenodd" d="M8.97 19L12.72 5H10C9.73478 5 9.48043 4.89464 9.29289 4.70711C9.10536 4.51957 9 4.26522 9 4C9 3.73478 9.10536 3.48043 9.29289 3.29289C9.48043 3.10536 9.73478 3 10 3H18C18.2652 3 18.5196 3.10536 18.7071 3.29289C18.8946 3.48043 19 3.73478 19 4C19 4.26522 18.8946 4.51957 18.7071 4.70711C18.5196 4.89464 18.2652 5 18 5H14.792L11.04 19H14C14.2652 19 14.5196 19.1054 14.7071 19.2929C14.8946 19.4804 15 19.7348 15 20C15 20.2652 14.8946 20.5196 14.7071 20.7071C14.5196 20.8946 14.2652 21 14 21H6C5.73478 21 5.48043 20.8946 5.29289 20.7071C5.10536 20.5196 5 20.2652 5 20C5 19.7348 5.10536 19.4804 5.29289 19.2929C5.48043 19.1054 5.73478 19 6 19H8.97Z" />
          </mask>
          <path fillRule="evenodd" clipRule="evenodd" d="M8.97 19L12.72 5H10C9.73478 5 9.48043 4.89464 9.29289 4.70711C9.10536 4.51957 9 4.26522 9 4C9 3.73478 9.10536 3.48043 9.29289 3.29289C9.48043 3.10536 9.73478 3 10 3H18C18.2652 3 18.5196 3.10536 18.7071 3.29289C18.8946 3.48043 19 3.73478 19 4C19 4.26522 18.8946 4.51957 18.7071 4.70711C18.5196 4.89464 18.2652 5 18 5H14.792L11.04 19H14C14.2652 19 14.5196 19.1054 14.7071 19.2929C14.8946 19.4804 15 19.7348 15 20C15 20.2652 14.8946 20.5196 14.7071 20.7071C14.5196 20.8946 14.2652 21 14 21H6C5.73478 21 5.48043 20.8946 5.29289 20.7071C5.10536 20.5196 5 20.2652 5 20C5 19.7348 5.10536 19.4804 5.29289 19.2929C5.48043 19.1054 5.73478 19 6 19H8.97Z" fill="#2C3E66" />
          <path d="M8.97 19V25H13.5744L14.7657 20.5524L8.97 19ZM12.72 5L18.5157 6.55242L20.5387 -1H12.72V5ZM10 3V-3V3ZM18 3V-3V3ZM14.792 5V-1H10.1883L8.99652 3.44681L14.792 5ZM11.04 19L5.24452 17.4468L3.22026 25H11.04V19ZM14.7657 20.5524L18.5157 6.55242L6.92431 3.44758L3.17431 17.4476L14.7657 20.5524ZM12.72 -1H10V11H12.72V-1ZM10 -1C11.3261 -1 12.5979 -0.473213 13.5355 0.464466L5.05025 8.94975C6.363 10.2625 8.14348 11 10 11V-1ZM13.5355 0.464466C14.4732 1.40214 15 2.67391 15 4H3C3 5.85652 3.7375 7.637 5.05025 8.94975L13.5355 0.464466ZM15 4C15 5.32609 14.4732 6.59785 13.5355 7.53553L5.05025 -0.949748C3.7375 0.363005 3 2.14348 3 4H15ZM13.5355 7.53553C12.5979 8.47322 11.3261 9 10 9V-3C8.14348 -3 6.36301 -2.2625 5.05025 -0.949748L13.5355 7.53553ZM10 9H18V-3H10V9ZM18 9C16.6739 9 15.4022 8.47322 14.4645 7.53553L22.9497 -0.949748C21.637 -2.26251 19.8565 -3 18 -3V9ZM14.4645 7.53553C13.5268 6.59784 13 5.32607 13 4H25C25 2.1435 24.2625 0.363016 22.9497 -0.949748L14.4645 7.53553ZM13 4C13 2.67393 13.5268 1.40216 14.4645 0.464466L22.9497 8.94975C24.2625 7.63699 25 5.8565 25 4H13ZM14.4645 0.464466C15.4022 -0.473217 16.6739 -1 18 -1V11C19.8565 11 21.637 10.2625 22.9497 8.94975L14.4645 0.464466ZM18 -1H14.792V11H18V-1ZM8.99652 3.44681L5.24452 17.4468L16.8355 20.5532L20.5875 6.55319L8.99652 3.44681ZM11.04 25H14V13H11.04V25ZM14 25C12.6739 25 11.4022 24.4732 10.4645 23.5355L18.9497 15.0503C17.637 13.7375 15.8565 13 14 13V25ZM10.4645 23.5355C9.52678 22.5979 9 21.3261 9 20H21C21 18.1435 20.2625 16.363 18.9497 15.0503L10.4645 23.5355ZM9 20C9 18.6739 9.52678 17.4022 10.4645 16.4645L18.9497 24.9497C20.2625 23.637 21 21.8565 21 20H9ZM10.4645 16.4645C11.4022 15.5268 12.6739 15 14 15V27C15.8565 27 17.637 26.2625 18.9497 24.9497L10.4645 16.4645ZM14 15H6V27H14V15ZM6 15C7.32607 15 8.59784 15.5268 9.53553 16.4645L1.05025 24.9497C2.36301 26.2625 4.1435 27 6 27V15ZM9.53553 16.4645C10.4732 17.4022 11 18.6739 11 20H-1C-1 21.8565 -0.262503 23.637 1.05025 24.9497L9.53553 16.4645ZM11 20C11 21.3261 10.4732 22.5979 9.53553 23.5355L1.05025 15.0503C-0.262503 16.363 -1 18.1435 -1 20H11ZM9.53553 23.5355C8.59784 24.4732 7.32607 25 6 25V13C4.1435 13 2.36301 13.7375 1.05025 15.0503L9.53553 23.5355ZM6 25H8.97V13H6V25Z" fill="#2C3E66" mask="url(#path-1-inside-1)" />
        </svg>
      ),
      underline: (
        <path d="M12.79 16.95C15.82 16.56 18 13.84 18 10.79V4.25C18 3.91848 17.8683 3.60054 17.6339 3.36612C17.3995 3.1317 17.0815 3 16.75 3C16.4185 3 16.1005 3.1317 15.8661 3.36612C15.6317 3.60054 15.5 3.91848 15.5 4.25V10.9C15.5 12.57 14.37 14.09 12.73 14.42C12.22 14.5299 11.6919 14.5242 11.1844 14.4033C10.6769 14.2824 10.2029 14.0494 9.79724 13.7214C9.39156 13.3934 9.06448 12.9788 8.84 12.5078C8.61552 12.0369 8.49934 11.5217 8.5 11V4.25C8.5 3.91848 8.3683 3.60054 8.13388 3.36612C7.89946 3.1317 7.58152 3 7.25 3C6.91848 3 6.60054 3.1317 6.36612 3.36612C6.1317 3.60054 6 3.91848 6 4.25V11C6 14.57 9.13 17.42 12.79 16.95ZM5 20C5 20.55 5.45 21 6 21H18C18.55 21 19 20.55 19 20C19 19.45 18.55 19 18 19H6C5.45 19 5 19.45 5 20Z" fill="#2C3E66" />
      ),
      points: (
        <svg width="24" height="24" viewBox="0 0 24 24">
          <circle cx="5" cy="12" r="2" transform="rotate(-90 5 12)" fill="#2C3E66" />
          <circle cx="12" cy="12" r="2" transform="rotate(-90 12 12)" fill="#2C3E66" />
          <circle cx="19" cy="12" r="2" transform="rotate(-90 19 12)" fill="#2C3E66" />
        </svg>
      )
    };

    <div className={classes.placeholder} value="none">
   
  </div>

    return (
      <div>
      <Select
        ref={this.setRef}
        onOpen={() => {
          this.setState({ isOpen: true });
          this.onRefChange();
        }}
        onClose={e => { if (e.currentTarget.className.indexOf('moreSettings') === -1) this.setState({ isOpen: false }); }}
        open={isOpen}
        MenuProps={{
          anchorReference: 'anchorPosition',
          anchorPosition: { top: topPosition, left: leftPosition },
          MenuListProps: {
            classes: {
              root: `${classes.selectMenuWrapper} ${classes.menuParams}`
            }
          },
          PopoverClasses: {
            paper: classes.popover,
          }
        }}
        style={{paddingRight: '17px'}}
        classes={{ selectMenu: classes.selectMenu, select: classes.selectMenu }}
        disableUnderline
        IconComponent={() => (<div onClick={() =>  this.someFunc()}>{settingIcons.points}</div>)}
        className={isOpen ? `${classes.select} ${classes.selectFocus}` : classes.select}
      >
        <div className={`${classes.moreSettings} moreSettings`}>
        <OpacitySelect
            layerOpacity={layer.opacity}
            onOpacityChange={value => changeSetting('opacity', value)}
          />
          
          <SettingButton
            onSettingChange={
              () => changeSetting(
                'fontStyle', layer.fontStyle === 'italic' ? 'normal' : 'italic'
              )
            }
            settingType="Italic"
            settingIcon={settingIcons.italic}
            settingActive={layer.fontStyle === 'italic'}
          />
          <SettingButton
            onSettingChange={() => changeSetting('underline', !layer.underline)}
            settingType="Underline"
            settingIcon={settingIcons.underline}
            settingActive={layer.underline}
          />
          <CaseSelect
            onCaseChange={value => changeSetting('textCase', value)}
            layerCase={layer.textCase}
          />
        </div>
      </Select>
      </div>
    );
  }
}

export default withStyles(styles)(MoreSettingsSelect);
